import React from "react";
import { CompareCardProps } from "./types";
import { Typography, useTheme } from "@mui/material";
import { StyledCard } from "./styles";

const CompareCard: React.FC<CompareCardProps> = ({ info, isBetter }) => {
  const theme = useTheme();

  return (
    <StyledCard theme={theme} isBetter={isBetter}>
      <Typography variant="body1" fontSize="14px" fontWeight="bold">
        {info.competidor}
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {info.precioLista}
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {info.paquete}
      </Typography>
      <Typography variant="body2" style={{gridColumn: "1/4"}}>
        {info.argumentos}
      </Typography>
    </StyledCard>
  );
};

export default CompareCard;
